var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('div',{staticClass:"header"},[_vm._v("Cliente "+_vm._s(_vm.tipo === 1 ? 'persona' : 'retail')),_c('b-badge',{staticClass:"ml-3",attrs:{"variant":"info"}},[_vm._v("Nuevo")])],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }